import { useMutation } from '@tanstack/react-query';

import { ApiWrapper } from '@/utils/api-wrapper';
import { getBuilderBaseUrl } from '@/utils/application';

async function createTemplateObjects(templates: string[]) {
  const response = await ApiWrapper.createObjectFromTemplates(templates);
  return response;
}

export function useCreateTemplateObjectsMutation() {
  return useMutation({
    mutationFn: (templates: string[]) => createTemplateObjects(templates),
    onSuccess: (response) => {
      const builderBaseUrl = getBuilderBaseUrl();

      if (response.objects.length > 0) {
        // Redirect to the last object added
        window.location.replace(
          `${builderBaseUrl}/schema/list/objects/${
            response.objects[response.objects.length - 1].key
          }/fields`
        );
      } else {
        // Redirect to the list of tables
        window.location.replace(`${builderBaseUrl}/schema/list`);
      }
    }
  });
}
